module.exports = __webpack_public_path__ + "theme/assets/img/9f7913362bab7200385ae995e84e3f75.svg";